// Decorate the public native link; its target and Shopify click handlers stay intact.
class RfPaymentOptions extends HTMLElement {
  connectedCallback() {
    this.observer = new MutationObserver(() => this.decorate());
    this.observer.observe(this, { childList: true, subtree: true });
    this.decorate();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  decorate() {
    const template = this.querySelector('template[data-payment-options-icons]');
    const link = this.querySelector('a.shopify-payment-button__more-options, button.shopify-payment-button__more-options');
    if (!template || !link || link.querySelector('.rf-payment-options__icons')) return;
    const label = link.textContent.trim();
    if (!label || link.getAttribute('aria-hidden') === 'true') return;
    link.setAttribute('aria-label', label);
    link.setAttribute('title', label);
    link.classList.add('rf-payment-options__link');
    link.replaceChildren(template.content.cloneNode(true));
  }
}

if (!customElements.get('rf-payment-options')) customElements.define('rf-payment-options', RfPaymentOptions);
